import { postRedeemCoupon } from './postRedeemCoupon';

export const couponService = {
  postRedeemCoupon: postRedeemCoupon,
};
